import styles from './MetricCard.module.scss';
import { Props } from './MetricCard.types';

const MetricCard = ({
  icon: Icon,
  label,
  value,
  unit,
  sub,
  variant = 'default',
  onClick,
}: Props) => {
  const className = [
    styles.container,
    variant === 'hero' ? styles.hero : '',
    onClick ? styles.clickable : '',
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      <Icon size={variant === 'hero' ? 28 : 22} className={styles.icon} />
      <div className={styles.body}>
        <span className={styles.label}>{label}</span>
        <div className={styles.valueRow}>
          <span className={styles.value}>{value}</span>
          {unit && <span className={styles.unit}>{unit}</span>}
        </div>
        {sub && <span className={styles.sub}>{sub}</span>}
      </div>
    </>
  );

  if (!onClick) {
    return <div className={className}>{content}</div>;
  }

  return (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );
};

export default MetricCard;
